// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

//---- JavintoAppPages
require("./packs/content/content_assets")
require("./packs/content/content_pages")

require("./packs/global");
require("./packs/global_bootstrap");

//---- FancyBox, see application.scss for CSS
import { Fancybox } from "@fancyapps/ui/dist/index.js";
document.addEventListener("turbo:load", () => {
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });  
});
document.addEventListener('turbo:before-cache', () => {
  Fancybox.destroy();
});
